<template>
  <div>
    <h1>{{ $t("delegationOrder.decision.title") }}</h1>
    <div class="mt-3 elevation-12 grey lighten-4">
      <div class="pa-4">
        <delegation-order-decision-form
          :delegation-decision.sync="delegationDecision"
          @accept="accept"
          @deny="deny"
          @denyAndRevert="denyAndRevert"
          @downloadSettlement="downloadSettlement"
        >
        </delegation-order-decision-form>
      </div>
      <v-card class="grey lighten-4">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="window.close()" color="blue darken-1" text>{{ $t("global.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import fileDownloadFunction from "../../../repository/downloadFile";
import DelegationOrderDecisionForm from "../../../components/DelegationOrder/DelegationOrderDecisionForm";
export default {
  name: "ActionByLinkDelegationOrderDecisionView",
  components: { DelegationOrderDecisionForm },
  data: () => ({
    delegationDecision: {}
  }),
  created() {
    // if (!(this.$route.params.type === 'financial' || this.$route.params.type === 'substantial')) {
    //     this.$router.push('/delegation');
    // }
    this.downloadDelegationDecision();
  },
  watch: {
    delegationDecision: {
      handler: function(after, before) {
        if (typeof before.advances === "object") {
          /*let result = */ this.$store.dispatch("alertDialog", {
            content: this.$t("global.notImplementedYet"),
            title: this.$t("global.error.generalError.title")
          });
        }
        //alert('Funkcjonalność edycji nie została jeszcze zaimplementowana.');
      },
      deep: true
    }
  },
  methods: {
    downloadSettlement() {
      fileDownloadFunction("token/delegation-order/document-preview?token=" + this.$route.params.token);
    },
    downloadDelegationDecision() {
      this.axios
        .get("token/delegation-order/get-decision?token=" + this.$route.params.token)
        .then(resp => {
          this.delegationDecision = resp.data;
        })
        .catch(() => {
          //console.log(res);
          this.$router.push("/action-by-link/" + this.$route.params.token);
        });
    },
    accept() {
      this.axios({
        url: "token/delegation-order/accept",
        data: { token: this.$route.params.token },
        method: "POST"
      })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$router.push("/action-by-link/" + this.$route.params.token);
          } else if (resp.data.status === "error") {
            //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
          }
        })
        .catch(() => {
          //TODO obsluga bledow
        });
    },
    deny(promptText) {
      this.axios({
        url: "token/delegation-order/reject",
        data: {
          token: this.$route.params.token,
          reason: promptText
        },
        method: "POST"
      })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$router.push("/action-by-link/" + this.$route.params.token);
          } else if (resp.data.status === "error") {
            //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
          }
        })
        .catch(() => {
          //TODO obsluga bledow
        });
    },
    denyAndRevert(promptText) {
      this.axios({
        url: "token/delegation-order/reject-and-back",
        data: {
          token: this.$route.params.token,
          reason: promptText
        },
        method: "POST"
      })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$router.push("/action-by-link/" + this.$route.params.token);
          } else if (resp.data.status === "error") {
            //TODO WYSWIETLENIE DYMKA BLEDU WALIDACJI
          }
        })
        .catch(() => {
          //TODO obsluga bledow
        });
    }
  },
  mounted() {
    this.$store.dispatch("Visual/setHalfBackground");
  },
  beforeDestroy() {
    this.$store.dispatch("Visual/setWhiteBackground");
  }
};
</script>

<style scoped></style>
